import { render, staticRenderFns } from "./addOrEditModal.vue?vue&type=template&id=46f48add&scoped=true"
import script from "./addOrEditModal.vue?vue&type=script&lang=js"
export * from "./addOrEditModal.vue?vue&type=script&lang=js"
import style0 from "./addOrEditModal.vue?vue&type=style&index=0&id=46f48add&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f48add",
  null
  
)

export default component.exports